/**
 * Shim for `styled-components/native`.
 *
 * The React Native build of styled-components exposes element factories such as
 * `styled.View` and `styled.Text`. The web build only exposes DOM tags
 * (`styled.div`, ...). This shim bridges the two by mapping RN element names to
 * the web primitives in `../react-native`, while still supporting
 * `styled(Component)` and re-exporting the rest of the styled-components API.
 */
import baseStyled, {
  ThemeProvider,
  ThemeContext,
  css,
  keyframes,
  createGlobalStyle,
  useTheme,
  withTheme,
  ServerStyleSheet,
  StyleSheetManager,
  isStyledComponent,
} from 'styled-components';

import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  TouchableHighlight,
  TouchableWithoutFeedback,
  Pressable,
  TextInput,
  Image,
  SafeAreaView,
  KeyboardAvoidingView,
  ActivityIndicator,
  FlatList,
  SectionList,
} from '../web/react-native';

const componentMap: Record<string, any> = {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  TouchableHighlight,
  TouchableWithoutFeedback,
  Pressable,
  TextInput,
  Image,
  SafeAreaView,
  KeyboardAvoidingView,
  ActivityIndicator,
  FlatList,
  SectionList,
};

const styled: any = new Proxy(baseStyled, {
  get(target: any, prop: string) {
    if (typeof prop === 'string' && componentMap[prop]) {
      return (target as any)(componentMap[prop]);
    }
    return target[prop];
  },
  apply(target: any, _thisArg, args: any[]) {
    return target(...args);
  },
});

export default styled;
export {
  css,
  keyframes,
  createGlobalStyle,
  ThemeProvider,
  ThemeContext,
  useTheme,
  withTheme,
  ServerStyleSheet,
  StyleSheetManager,
  isStyledComponent,
};
